import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  InputBase,
} from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";

export default function CheckBoxEquipment({ label, dynamic, value, ...props }) {
  const [checked, setChecked] = useState(false);
  const [dynamicLabel, setDynamicLabel] = useState();

  const handleChange = (event) => {
    setChecked(event.target.checked);
    if (dynamic && dynamicLabel && !event.target.checked && props.onChange)
      props.onChange(undefined, dynamicLabel);
    else if (!dynamic && !event.target.checked && props.onChange) {
      props.onChange(undefined, label);
    }
  };
  useEffect(() => {
    if (value >= 1) setChecked(true);
  }, []);
  return (
    <Box justifyContent="space-between" display="flex" alignItems="center">
      <Grid>
        <FormControlLabel
          sx={{
            mr: "-10px",
            "& .MuiButtonBase-root": {
              color: "var(--emr-darkblue) !important",
            },
            "& .MuiTypography-root": {
              fontSize: "12px",
              width: dynamic ? "fit-content" : "100%",
            },
          }}
          control={<Checkbox checked={checked} onChange={handleChange} />}
          label={
            label ? label : checked ? "" : dynamic ? "نام را وارد کنید" : ""
          }
        />
        {!label && checked && dynamic && (
          <InputBase
            onChange={(e) => setDynamicLabel(e.target.value)}
            sx={{ marginRight: "10px" }}
            autoFocus
            placeholder="نام را وارد کنید"
          />
        )}
      </Grid>
      <Box
        sx={{
          border: "solid 1px var(--emr-borderInput)",
          borderRadius: "8px",
          px: "10px",
          height: "30px",
          display: "flex",
          boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
          opacity: checked ? "1" : "0.4",
        }}
      >
        {dynamic && (
          <InputBase
            {...props}
            onChange={(e) => props.onChange(e.target.value, dynamicLabel)}
            sx={{ fontSize: "11px" }}
            disabled={!checked}
            value={value}
            placeholder="تعداد را وارد کنید."
          />
        )}
        {!dynamic && (
          <InputBase
            {...props}
            sx={{ fontSize: "11px" }}
            disabled={!checked}
            value={value}
            placeholder="تعداد را وارد کنید."
          />
        )}
      </Box>
    </Box>
  );
}
